import React from 'react';
import { auth } from '../../Services/Firebase/firebaseConnection'

import { useNavigate } from "react-router-dom";
import { Button, Flex } from '@chakra-ui/react';

import { RiAdminLine } from "react-icons/ri";
import { RiLogoutBoxLine } from "react-icons/ri";
import { RiLoginBoxLine } from "react-icons/ri";

import { onAuthStateChanged, signOut } from 'firebase/auth';

export default function BtnAdm() {
  const [isloged, setisloged] = React.useState(false)
  const navigate = useNavigate()


  React.useEffect(() => {

    async function checkLogin(){

      onAuthStateChanged(auth, (user) => {
        if(user){
          setisloged(true)
        }else{
          setisloged(false)
        }
      })
    }

    checkLogin();

  }, [])
  
  async function redireciona(){
    if(!isloged) {
      navigate('/login')
    } else {
      navigate('/admin')
    }
  }

  async function logout(){
    localStorage.removeItem('@userData')
    await signOut(auth)
    setisloged(false)
    navigate('/login')
  }

  return (
    <Flex gap='1'>

      {isloged && (
      <Button 
      size={'xs'}
      fontSize='8'
      rightIcon={<RiAdminLine />}
       colorScheme='orange'
       variant='solid' 
       borderRadius='full'
       onClick={redireciona}
       > ADM </Button>
      )}

      <Button 
      size={'xs'}
      fontSize='8'
      rightIcon={isloged ? <RiLogoutBoxLine /> : <RiLoginBoxLine />}
       colorScheme={isloged ? 'red' : 'whiteAlpha'}
       variant={'solid' }
       borderRadius='full'
       onClick={ isloged ? logout : redireciona }
       >
        {isloged ? 'SAIR' : 'ORG: VANVAN'}
      </Button>
    </Flex>
  );
}